<template>
    <f-button
        class="common-btn"
        :disabled="disabled"
        text="Button"
        :type="type"
        :danger="isDanger"
        :small="isSmall"
        @click="handleClick"
    >
        <slot name="icon"/> 
        {{ `${text}` }}
    </f-button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ButtonType } from "./HelpersInterface";

export default defineComponent({
    props: {
        text: {
            type: String,
            default: "Button",
        },
        type: {
            type: String as PropType<ButtonType>,
            default: ButtonType.Primary,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isDanger: {
            type: Boolean,
            default: false,
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["click"],
    methods: {
        handleClick(event: MouseEvent) {
            if (!this.disabled) {
                this.$emit("click", event);
            }
        },
    },
});
</script>

<style scoped>
.common-btn {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    margin: 0 !important;
}
</style>
